// Activity Tracking Service
// Handles API calls for activity logging

import httpMethods from '@/services/httpClient';

export interface ActivityLogResponse {
  success: boolean;
  message?: string;
}

class ActivityTrackingService {
  private readonly ENDPOINTS = {
    LOG_ACTIVITY: '/student/activity/log',
  };

  /**
   * Log user activity (creates or extends session)
   * Backend handles: 10min extension, 5min grace period, 8hr max session
   */
  async logActivity(): Promise<ActivityLogResponse> {
    try {
      const response = await httpMethods.post<ActivityLogResponse>(
        this.ENDPOINTS.LOG_ACTIVITY
      );
      return response;
    } catch (error: any) {
      console.error('[ActivityTracking] Failed to log activity:', error);
      // Don't throw - tracking should fail silently
      return {
        success: false,
        message: error?.message || 'Failed to log activity'
      };
    }
  }
}

export default new ActivityTrackingService();
